/**
 * Flattens the nested workout hierarchy (phases → rounds → sets → items)
 * into a linear array of Steps for the presenter view.
 *
 * Step types:
 *   { type: 'phase_intro', phase }
 *   { type: 'exercise',    phase, round, roundRep, set, setRep, item, exercise }
 *   { type: 'rest',        duration, label, phase, round }
 */
export function flattenWorkout(workout) {
  const steps = [];

  for (const phase of workout.phases || []) {
    steps.push({ type: 'phase_intro', phase });

    for (const round of phase.rounds || []) {
      const roundReps = round.repetitions || 1;

      for (let roundRep = 1; roundRep <= roundReps; roundRep++) {
        for (const set of round.sets || []) {
          const setReps = set.repetitions || 1;

          for (let setRep = 1; setRep <= setReps; setRep++) {
            for (const item of set.items || []) {
              steps.push({
                type: 'exercise',
                phase,
                round,
                roundRep,
                roundReps,
                set,
                setRep,
                setReps,
                item,
                exercise: item.exercise,
              });

              if (item.rest_after > 0) {
                steps.push({
                  type: 'rest',
                  duration: item.rest_after,
                  label: 'Pause',
                  phase,
                  round,
                  nextExercise: null, // filled below
                });
              }
            }

            if (setRep < setReps && (set.rest_between_reps || 0) > 0) {
              steps.push({
                type: 'rest',
                duration: set.rest_between_reps,
                label: 'Pause zwischen Sätzen',
                phase,
                round,
              });
            }
          }
        }

        if (roundRep < roundReps && (round.rest_between_reps || 0) > 0) {
          steps.push({
            type: 'rest',
            duration: round.rest_between_reps,
            label: 'Pause zwischen Runden',
            phase,
            round,
          });
        }
      }
    }
  }

  // Back-fill nextExercise on rest steps
  for (let i = 0; i < steps.length; i++) {
    if (steps[i].type === 'rest') {
      const next = steps.slice(i + 1).find((s) => s.type === 'exercise');
      steps[i].nextExercise = next ? next.exercise : null;
    }
  }

  return steps;
}
